<template>
    <div>
        <input
            class="input"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @blur="$emit('blur')"
            :placeholder="placeholder"
        />
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'

export default {
    props: ['value', 'field'],
    computed: {
        placeholder() {
            return Form.placeholder(this.field)
        },
    },
}
</script>
